import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CookieService } from 'ngx-cookie-service';
import {SharedService} from 'src/app/shared.service';
import { TranslateService } from '@ngx-translate/core';
import {Router} from "@angular/router";
import {MatSnackBar} from '@angular/material/snack-bar';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-mfa',
  templateUrl: './mfa.component.html',
  styleUrls: ['./mfa.component.css']
})
export class MFAComponent implements OnInit {

  getLanguage():string{
    if (localStorage){
        return localStorage['language'] || "";
    }
    else{
        return "";
    }
}

setLanguage(language: string){
    if (localStorage){
        localStorage['language'] = language;
    }
}

  constructor(private service:SharedService, private cookieService: CookieService, public translate: TranslateService, private router:Router,  private _snackBar: MatSnackBar) {

    translate.addLangs(['en', 'ro']);
    translate.setDefaultLang('en');

    const browserLang = this.getLanguage();
    translate.use(browserLang.match(/en|ro/) ? browserLang : 'en');

   }

  User:any;
  MFAToken:string;
  loading:boolean;
  AppAccess:any[];
  SelectedAppAccess:any;
  Company:any;

  ngOnInit(): void {
    this.User = JSON.parse(localStorage.getItem("User"));

    if(this.User == null){
     this.router.navigate(['login'])
    }
    else{
      this.GetUserAppAccess();
    }
  }

  compareFn(c1: any, c2: any): boolean {
    return c1 && c2 ? c1.Application.ID === c2.Application.ID : c1 === c2;
}

GetUserAppAccess(){
  var request = {
    User:this.User,
    Language:this.getLanguage(),
    UserID:this.User.Id
  };

  this.loading = true;

  this.service.GetUserAppAccess(request).subscribe(response => {
 
    if(response["Status"] == -1){
      this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.AppAccess = response["UserAppAccess"];
      this.AppAccess = this.AppAccess.filter(x => x.Access == true);
      this.SelectedAppAccess = this.AppAccess.find(x => x.IsSelected == true);

      if(this.SelectedAppAccess == null || this.AppAccess == null || this.AppAccess?.length == 0){
        this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(this.AppAccess?.length == 1){
        this.ChooseApplication(this.SelectedAppAccess.Application);
      }
      else{
        // this.GetUserLastUsedCompany();
      }
      
    }

    this.loading = false;
  });
}

  VerifyMFAToken(){
    var request = {
      User:this.User,
      Language:this.getLanguage(),
      Token:this.MFAToken
    };

    this.loading = true;

    this.service.VerifyMFAToken(request).subscribe(response => {

      if(response["Status"] != 1){
        this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        this.loading = false;
      }
      else if(response["Status"] == 1){
          this.cookieService.set( 'MFAuthToken', JSON.stringify(true), 5, "/");
          this.UpdateUserLastSelectedApplication(this.SelectedAppAccess.Application);
      }
    });
  }

  ChooseApplication(app:any){
    if(app.RequiresToken != true){
      this.UpdateUserLastSelectedApplication(app);
    }
  }

  UpdateUserLastSelectedApplication(App:any){

    var request = {
      User:this.User,
      Language:this.getLanguage(),
      UserID:this.User.Id,
      ApplicationID:App.ID
    };
  
    this.loading = true;
  
    this.service.UpdateUserLastSelectedApplication(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        localStorage.removeItem('User');
        localStorage.setItem('User', JSON.stringify(this.User));

        setTimeout(()=>{                           
          this.RedirectToURLWithUrlChange(App.MainURL)
          this.loading = false;
      }, 0);
      }
    });
  }

  RedirectToURLWithUrlChange(url:string){
    this.router.navigate([url], { replaceUrl: true }); 
  }

  openSnackBar(message: string, action: string, designClass: string) {
    this._snackBar.open(message, action, {
      duration: 5000,
      panelClass: [designClass]
    });
  }

  GetUserLastUsedCompany(){
    var request = {
      User:this.User,
      Language:this.getLanguage(),
      UserID:this.User.Id
    };
  
    this.service.GetUserLastUsedCompany(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Company = response["LastUsedCompany"];

          this.User.Rights.AssignedCompanies.forEach(element => {
            if(element.ID == this.Company?.ID){
              element.IsSelected = true;
            }
            else{
              element.IsSelected = false;
            }
          });

          if(!this.Company && this.User.Rights.AssignedCompanies != null && this.User.Rights.AssignedCompanies.length > 0){
            this.User.Rights.AssignedCompanies[0].IsSelected = true;
            this.Company = this.User.Rights.AssignedCompanies[0];
          }
      
          localStorage.removeItem('User');
          localStorage.setItem('User', JSON.stringify(this.User));
      }
    })
  }

  LogOff(){
    localStorage.removeItem("User");
    this.cookieService.delete("MFAuthToken", "/");
    window.location.reload();
  }

}
